function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m350 21.875c-180.91 0-328.12 147.22-328.12 328.12s147.22 328.12 328.12 328.12 328.12-147.22 328.12-328.12-147.22-328.12-328.12-328.12zm-3.5 546.88c-27.016 0-49-19.578-49-43.75s21.984-43.75 49-43.75 49 19.578 49 43.75-21.984 43.75-49 43.75zm36.75-201.47v37.406c0 18.156-16.406 32.812-36.75 32.812s-36.75-14.656-36.75-32.812v-54.688c0-24.172 21.984-43.75 49-43.75 0 0 48.672 0 48.672-49.328 0-32.812-25.156-60.047-60.922-60.047-25.375 0-47.141 13.781-56.438 33.359-5.9062 12.578-18.812 21.328-34.125 21.328h-0.875c-25.812 0-43.312-23.406-33.688-44.844 21.656-48.234 77.219-80.934 140.43-74.703 61.797 6.125 112 51.078 118.57 106.32 7.2188 60.812-36.094 113.64-97.238 128.95z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help_icon.58f708e457065f6ef54be9b4de8d91c1.svg";
export { ForwardRef as ReactComponent };